import React,{useState} from 'react'
import Grid from './Grid'
import { getSectionSettings, ProjectConfiguration, updateSectionSettings } from 'utils/ProjectConfigurationUtil';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid'
import { useCanDoAction } from 'hooks/useCanDoAction';


const SectionSettings = () => {
    const { selectedProject, forceUpdate } = useAppContext() //Getting the App Context
    const canUpdate = useCanDoAction('ProjectConfig', 'update');
    const columns = ProjectConfiguration.columns.filter(col => col.title !== "name")
    const title = "Section Settings"
    const getFormPath = () => import('components/Shared/SkeletonForm');
    const [updateDate, setUpdateDate] = useState(new Date());
    //Callback to update the Project Configuration Settings
    //TODO: Handle the user selection toggle 
    const receiveSettings = (evt, sectionSettingData) => {
        const data = JSON.parse(sectionSettingData)
        delete data['tableData']
        data['value'] === 'Hide' ? data['value'] = true : data['value'] = false
        updateSectionSettings(data, selectedProject).then(r => {
            setUpdateDate(new Date());
            forceUpdate();
        })
    }
    const selection = { "display": canUpdate, "callback": receiveSettings, "tooltip": "", "btnText": "Update Settings" }
    
    return (
        <div key={updateDate}>
            {
                selectedProject ?
                    <Grid columns={columns} title={title} getRecords={getSectionSettings} selectedProject={selectedProject} paging={false} component="Samples" formPath={getFormPath} selection={selection} /> : <SkeletonGrid title={title} />
            }
        </div>
    )

}

export default SectionSettings
